import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { TablerCaretUpDownFilled } from "../../assets/icons/LayoutIcon";
import useSortableData from "../../utils/SortData";
import EmptyTable from "./EmptyTable";
import { Eye, SquarePen } from "lucide-react";
import { getStatusClass, getOrderStatusClass } from "./StatusStyle";

const TableLayout = ({ data = [], loading, headers = [], handleAction }) => {
  const { sortedItems, handleSort } = useSortableData(data);

  const renderTableCell = (item, header) => {
    switch (header) {
      case "tracking_status":
        return (
          <span className={getStatusClass(item.tracking_status)}>
            {item.tracking_status}
          </span>
        );
      case "order_status":
        return (
          <span className={getOrderStatusClass(item.order_status)}>
            {item.order_status}
          </span>
        );
      // case "revenue":
      //   return `₹${item.revenue.toLocaleString()}`;
      // case "totalSales":
      //   return item.totalSales.toLocaleString();
      default:
        return <span className="text-sm sm:text-xs">{item[header] || ""}</span>;
    }
  };
  const renderActionButtons = (header, item) => {
    // Check if this is the action column
    if (header.value === "action") {
      return (
        <div className="flex items-center space-x-2">
          {/* View button - always present */}

          {header.isEdit ? (
            <button
              className="text-xs text-gray-400 px-0 sm:px-1.5 py-0.5 "
              onClick={() => handleAction && handleAction(item)}
              title="Edit"
            >
              <SquarePen className="text-gray-400 h-4 w-4" />
            </button>
          ) : (
            <button
              className="text-xs text-gray-400 px-0 sm:px-1.5 py-0.5"
              onClick={() => handleAction(item)}
              title="View"
            >
              <Eye className="text-gray-400 h-4 w-4" />
            </button>
          )}
        </div>
      );
    }
  };
  return (
    <div className="flex-1 w-full overflow-hidden ">
      <div className="rounded-lg sm:border border-gray-300 overflow-x-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100  my-6 sm:my-4   ">
        <div className="w-full">
          <Table className=" border-gray-300 rounded-md">
            <Thead className="bg-gray-100  ">
              <Tr>
                {headers.map((header, index) => (
                  <Th
                    key={index}
                    className="px-3 py-3 text-left font-semibold text-xs text-text1 cursor-pointer whitespace-nowrap"
                    onClick={() =>
                      header.value !== "action" && handleSort(header.value)
                    }
                  >
                    {header.value !== "action" ? (
                      <div className="flex items-center ">
                        <TablerCaretUpDownFilled className="transition-transform hidden sm:block" />
                        <span className="text-text1 text-sm sm:text-xs font-semibold">
                          {header.label}
                        </span>
                      </div>
                    ) : (
                      <span className="text-text1 text-sm sm:text-xs font-semibold mr-2">
                        {header.label}
                      </span>
                    )}
                  </Th>
                ))}
              </Tr>
            </Thead>

            <Tbody>
              {sortedItems.length > 0 ? (
                sortedItems.map((item, index) => (
                  <Tr key={index} className="border-t hover:bg-gray-50">
                    {headers.map((header) => (
                      <Td
                        key={header.value}
                        className={`px-3 py-4 text-sm sm:text-xs font-normal text-text2 whitespace-nowrap ${
                          header.value === "action" ? "w-auto" : ""
                        }`}
                      >
                        {header.value === "action"
                          ? renderActionButtons(header, item)
                          : renderTableCell(item, header.value)}
                      </Td>
                    ))}
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td
                    colSpan={headers.length}
                    className="text-center text-gray-500"
                  >
                    <EmptyTable isApiLoading={loading} />
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default TableLayout;
